import MultiPrint from './MultiPrint';
export default MultiPrint;
